export default {
    topics: [
        {
            title: ' AcceptCus ',
            href: 'sm-conflict-AcceptCus.html',
            attributes: { 'data-id': 'sm-conflict-AcceptCus' },
            menu: { hasChildren: false },
            tocID: 'sm-conflict-AcceptCus-d66e369',
            topics: [],
        },
        {
            title: ' AcceptNew ',
            href: 'sm-conflict-AcceptNew.html',
            attributes: { 'data-id': 'sm-conflict-AcceptNew' },
            menu: { hasChildren: false },
            tocID: 'sm-conflict-AcceptNew-d66e377',
            topics: [],
        },
        {
            title: ' SetResolved ',
            href: 'sm-conflict-SetResolved.html',
            attributes: { 'data-id': 'sm-conflict-SetResolved' },
            menu: { hasChildren: false },
            tocID: 'sm-conflict-SetResolved-d66e385',
            topics: [],
        },
    ],
};

